/**
 * Tri par en-tête de colonne, réutilisé par tous les tableaux admin (section 8.1).
 * - 1er clic : A→Z (asc), 2e clic : Z→A (desc).
 * - Les nombres/dates se trient sur leur valeur réelle ; le texte sans accents ni casse (locale fr).
 */
import { useMemo, useState } from 'react';

const collator = new Intl.Collator('fr', { sensitivity: 'base', numeric: true });

function compare(a, b) {
  if (a == null && b == null) return 0;
  if (a == null) return 1; // valeurs vides toujours en bas
  if (b == null) return -1;
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  return collator.compare(String(a), String(b));
}

export function useSortableTable(rows, getters, defaultSort) {
  const [sort, setSort] = useState(defaultSort || { key: null, dir: 'asc' });

  const sorted = useMemo(() => {
    if (!sort.key || !getters[sort.key]) return rows;
    const get = getters[sort.key];
    const copy = [...rows];
    copy.sort((ra, rb) => {
      const r = compare(get(ra), get(rb));
      return sort.dir === 'asc' ? r : -r;
    });
    return copy;
  }, [rows, sort, getters]);

  const toggle = (key) =>
    setSort((s) => (s.key === key ? { key, dir: s.dir === 'asc' ? 'desc' : 'asc' } : { key, dir: 'asc' }));

  return { sorted, sort, toggle };
}

/** En-tête de colonne triable (flèche ↑/↓, soulignement sur la colonne active). */
export function SortableTh({ label, sortKey, sort, toggle, className = '', align = 'left' }) {
  const active = sort.key === sortKey;
  return (
    <th
      className={`adm-th ${active ? 'adm-th-active' : ''} ${className} text-${align} font-medium`}
      onClick={() => toggle(sortKey)}
      data-testid={`sort-${sortKey}`}
    >
      {label}
      {active && <span className="ml-1">{sort.dir === 'asc' ? '↑' : '↓'}</span>}
    </th>
  );
}
